class Settings {
    wow_server_url =
        process.env.REACT_APP_ENV === 'LOCAL' ? 'https://localhost:4008' : 'https://api.igame.wowhaus.xyz:4008';
}

const settings = new Settings();
export default settings;
